import { defineComponent as _defineComponent } from 'vue'
import { computed as _computed } from 'vue';

export interface SMenuButtonProps {
  /**
   * Whether the button is disabled or not.
   */
  disabled?: boolean;
  /**
   * Route to navigate to.
   */
  to?: string | object | null
  /**
   * Text to be displayed in the button.
   */
  text?: string;
  /**
   * Text to be displayed at the right of the button.
   */
  secondary_text?: string;
  /**
   * Tooltip to be displayed when hovering the button.
   */
  tooltip?: string;
  /**
   * Icon to be displayed in the button.
   */
  icon?: string;
  /**
   * Button color (`primary` or `danger`). `primary` by default.
   */
  color?: 'primary' | 'danger';
  /**
   * data-track attribute for testing purposes.
   */
  dataTrack?: string
  /**
   * submenu flag
   */
  submenu?: boolean
}

type Emits = {
  /**
   * Click event emitted when the button is clicked.
   */
  (event: 'click', e: MouseEvent): void
}


import { defineComponent as __MACROS_defineComponent } from "vue";
const __default__ = __MACROS_defineComponent({
  inheritAttrs: false,
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'SMenuButton',
  props: {
  disabled: { type: Boolean, default: false },
  to: null,
  text: null,
  secondary_text: null,
  tooltip: null,
  icon: null,
  color: { default: 'primary' },
  dataTrack: null,
  submenu: { type: Boolean }
},
  emits: ["click"],
  setup(__props, { emit: emits }) {

const props = __props;




;

const iconColor = _computed(() => {
  if (props.color === 'danger' && !props.disabled) {
    return 'iconDanger';
  }
  return undefined;
});

const textClasses = _computed(() => {
  const result = [];
  if (props.color === 'danger' && !props.disabled) {
    result.push('textDanger--text');
  }
  return result;
});

const link = _computed(() => {
  if (!props.to) return false;

  const isExternalLink = props.to.toString().startsWith('http');

  return {
    [isExternalLink ? 'href' : 'to']: props.to,
    target: isExternalLink ? '_blank' : undefined,
  };
});

const click = async (event: MouseEvent) => {
  emits('click', event);
};


return { __sfc: true,props, emits, iconColor, textClasses, link, click, __MACROS_defineComponent, _computed }
}

})